import { configureStore } from '@reduxjs/toolkit';
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  createTransform,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import actions, { setActionsForPage } from './actions';
import { getReducerForPage } from './reducers';

export const createStoreForPage = (pageType) => {
  setActionsForPage(pageType);

  let key;
  let whitelist;

  switch (pageType) {
    case 'control-center':
    case 'mission-hub':
      key = 'root-with-map';
      whitelist = ['map'];
      break;

    default:
      key = 'root-without-map';
      whitelist = [];
      break;
  }

  const persistConfig = {
    key,
    storage,
    transforms: [
      createTransform(
        (inboundState) => {
          if (Object.prototype.hasOwnProperty.call(inboundState, 'pointer')) {
            const { pointer, ...rest } = inboundState;
            return rest;
          }
          return inboundState;
        },
        (outboundState) => outboundState,
        { whitelist: ['map'] },
      ),
    ],
    whitelist,
  };

  const persistedReducer = persistReducer(persistConfig, getReducerForPage(pageType));

  const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: { ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER] },
      }),
  });

  // Store에 reset 메서드 추가
  store.resetAll = () => {
    // 현재 페이지에 설정된 모든 액션의 reset 호출
    Object.values(actions).forEach((actionGroup) => {
      if (actionGroup.reset) {
        try {
          store.dispatch(actionGroup.reset());
        } catch (e) {
          // 함수 처리 중 예외 발생 시 무시
        }
      }
    });
  };

  const persistor = persistStore(store);

  return { store, persistor };
};
